import $ from 'jquery'

export function hideHotJarIfMobilePortrait () {
  const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
  if (width < 500 && height < 800 && width < height) {
    $('#_hj_feedback_container').hide()
  } else {
    $('#_hj_feedback_container').show()
  }
}

export function addHotJar (trackingCode) {
  if (!trackingCode || trackingCode === '') {
    return
  }
  (function (h, o, t, j, a, r) {
    h.hj =
      h.hj ||
      function () {
        (h.hj.q = h.hj.q || []).push(arguments)
      }
    h._hjSettings = { hjid: trackingCode, hjsv: 6 }
    a = o.getElementsByTagName('head')[0]
    r = o.createElement('script')
    r.async = 1
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv
    a.appendChild(r)
  })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=')

  // Give HotJar widget time to load.
  window.setTimeout(function () {
    hideHotJarIfMobilePortrait()
  }, 1000)
}
